import Layout from "./components/layout/layout";


function App() {
    return (
        <Layout>
        </Layout>
    );
}

export default App;
